import { buildQuery } from "helpers/reqparams";
import { body, request } from "services/request";

const PER_PAGE = 20;

const resource = "api/techSupportChat";

const sendMessage = (params: {}) => request(`${resource}/sendMessage`, body(params));

const sendFileMessage = (params: {}) => request(`${resource}/sendFileMessage`, params);

const getMessages = (page: number) => {
    const query = { top: PER_PAGE, skip: PER_PAGE * page, orderBy: ["id desc"] };
    return request(`${resource}/getMessages${buildQuery(query)}`, { method: "GET" });
};

const setMessagesAsRead = () => request(`${resource}/setMessagesAsRead`, body({}));

const getHasUnreadMessages = () => request(`${resource}/getHasUnreadMessages`, { method: "GET" });

export { sendMessage, sendFileMessage, getMessages, setMessagesAsRead, getHasUnreadMessages, PER_PAGE };
